<div class="tank-debunker relative pb-4">
  <div class="reorder">
    <re-reorder-buttons (reorder)="onReorder($event)" />
  </div>

  <div class="delete absolute top-4 right-4">
    <re-trash-button (delete)="onDelete()" />
  </div>

  <h2 class="transfer-header mb-4 text-center">Speed & Distance</h2>

  <div class="main mb-4 flex flex-col">
    <re-form-field
      fieldGroup="speedAndDistance"
      [fieldLabel]="`Log Speed`"
      [fieldType]="fieldType.Number"
      [required]="false"
      [fieldUnit]="`Knots`"
      [labelWidthPercentage]="60"
    />

    <re-form-field
      fieldGroup="speedAndDistance"
      [fieldLabel]="`Log Distance`"
      [fieldType]="fieldType.Number"
      [required]="false"
      [fieldUnit]="`NM`"
      [labelWidthPercentage]="60"
    />

    <re-form-field
      fieldGroup="speedAndDistance"
      [fieldLabel]="`Course Over Ground (COG)`"
      [fieldType]="fieldType.Number"
      [required]="false"
      [fieldUnit]="`NM`"
      [labelWidthPercentage]="60"
    />

    <re-form-field
      fieldGroup="speedAndDistance"
      [fieldLabel]="`Observed Speed`"
      [fieldType]="fieldType.Number"
      [required]="false"
      [fieldUnit]="`Knots`"
      [labelWidthPercentage]="60"
    />

    <re-form-field
      fieldGroup="speedAndDistance"
      [fieldLabel]="`Observed Distance`"
      [fieldType]="fieldType.Number"
      [required]="false"
      [fieldUnit]="`NM`"
      [labelWidthPercentage]="60"
    />

    <re-form-field
      fieldGroup="speedAndDistance"
      [fieldLabel]="`Observed Distance In ECA`"
      [fieldType]="fieldType.Number"
      [required]="false"
      [fieldUnit]="`NM`"
      [labelWidthPercentage]="60"
    />

    <re-form-field
      fieldGroup="speedAndDistance"
      [fieldLabel]="`Total Sea Passage Observed Distance`"
      [fieldType]="fieldType.Number"
      [required]="false"
      [fieldUnit]="`NM`"
      [labelWidthPercentage]="60"
    />

    <re-form-field
      fieldGroup="speedAndDistance"
      [fieldLabel]="`Remaining Distance`"
      [fieldType]="fieldType.Number"
      [required]="false"
      [fieldUnit]="`NM`"
      [labelWidthPercentage]="60"
    />

    <re-form-field
      fieldGroup="speedAndDistance"
      [fieldLabel]="`Bad Weather Hours`"
      [fieldType]="fieldType.Number"
      [required]="false"
      [fieldUnit]="`Hours`"
      [labelWidthPercentage]="60"
    />

    <re-form-field
      fieldGroup="speedAndDistance"
      [fieldLabel]="`Bad Weather Observed Distance`"
      [fieldType]="fieldType.Number"
      [required]="false"
      [fieldUnit]="`Hours`"
      [labelWidthPercentage]="60"
    />
  </div>
</div>
